import { Meta } from '@/src/components/common/Meta';
import JamProfileDetailsUnifiedProfile from '@/src/components/game/Account/JamProfileDetailsUnifiedProfile';
import { i18nKeys } from '@/src/utils/i18n.utils';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const ProfileDetailsPage: React.FC = () => {
  const { t } = useTranslation();

  const pageTitle = `${t(i18nKeys.JamProfile.jamProfileDetails.title)} | ${t(i18nKeys.meta.profile.title)}`;

  return (
    <>
      <Meta title={pageTitle} />
      <JamProfileDetailsUnifiedProfile />
    </>
  );
};
